import {Injectable, Injector} from "@angular/core";
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs/Observable";
import {LoginProvider} from "../login/login.provider";
import {App, NavController} from "ionic-angular";
import {LoginPage} from "../../pages/login/login";
import {GlobalProvider} from "../global/global";

@Injectable()

export class CrHttpInterceptor implements HttpInterceptor {

  private loginProvider = null;
  constructor(private injector: Injector, private app: App){
    setTimeout(() => {
      this.loginProvider = injector.get(LoginProvider);
    })
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // req = req.clone({withCredentials: true});

    return next.handle(req)
      .do((event: HttpEvent<any>) => {
        console.dir('test');
      }, (error: any) => {
        if(error instanceof  HttpErrorResponse){

          switch ((<HttpErrorResponse>error).status) {
            case 400:
              return this.handle400Error(error);
            case 401:
              return this.handle401Error(error, req, next);
          }
        }
      })
      .catch((error, caught) => {
        return Observable.throw(error);
      })

  }

  private handle400Error(error: HttpErrorResponse){
    console.dir(error.message);
  }

  private handle401Error(error: HttpErrorResponse, req: HttpRequest<any>, next: HttpHandler){
    console.dir(error.message);
    this.loginProvider.setLoggedOut('Username or Password wrong');
  }

}



// WEBPACK FOOTER //
// ./src/providers/interceptors/crHttpInterceptor.ts